export default {
  setRestrictedDeposit(state, value) {
    state.restrictedDeposit = value
  },
  reset(state) {
    const initial = state
    Object.keys(initial).forEach(key => {
      state[key] = ''
    })
  },
  SET_CCVALIDATEDIALOGVISIBLE(state, value) {
    state.ccValidateDialogVisible = value
  },
  setDisableOtherMethod(state, value) {
    state.disableOtherMethod = value
  },
  setHasAvailableCard(state, value) {
    state.hasAvailableCard = value
  },
  setWithdrawSortInfo(state, value) {
    state.withdrawSortInfo = value
  },
  setBridgePayData(state, value) {
    state.bridgePayData = value
  },
  setCheckoutCCData(state, value) {
    state.checkoutCCData = value
  },
  setIsUsePcs(state, value) {
    state.isUsePcs = value
  },
  setPCSI18n(state, value) {
    state.PCSI18n = value
  },
  setOrderInfo(state, value) {
    state.orderInfo = value;
  },
  setDefaultDepositAccountNum(state, value) {
    state.defaultDepositAccountNum = value
  },
}
